/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const formatMilliseconds = (milliseconds: number): string => {
  if (milliseconds < 1000) {
    return `${milliseconds}ms`;
  }

  let seconds = parseFloat((milliseconds / 1000).toFixed(2));
  if (seconds < 60) {
    return `${seconds}s`;
  }

  const minutes = Math.floor(seconds / 60);
  seconds = parseFloat((seconds % 60).toFixed(0));
  return `${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`;
};
